
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.167 6v1h-7a.667.667 0 00-.66.568l-.007.099v11.666c0 .335.247.612.568.66l.099.007h11.666a.667.667 0 00.66-.568l.007-.099v-7h1v7c0 .872-.67 1.588-1.523 1.66l-.144.007H5.167c-.872 0-1.588-.67-1.66-1.523l-.007-.144V7.667c0-.872.67-1.588 1.523-1.66L5.167 6h7zM21.5 3v6.5h-1V4.706L9.354 15.854l-.708-.708L19.793 4 15 4V3h6.5z","fill":"#373534","fill-rule":"evenodd"}})])
          )
        }
      }
    